import React from 'react';
import classNames from 'classnames';
import { Stack } from '@mui/material';
import PopoverCustom from '../../components/popover';

type IconToastWarning2Props = {
  size?: number;
  colorError?: boolean;
  colorWarning?: boolean;
  text?: string;
};

export const IconToastWarning2: React.FC<IconToastWarning2Props> = ({
  size = 24,
  colorError = false,
  colorWarning = false,
  text,
}) => {
  const color = `var(--color-${colorError ? 'red' : 'warning'})`;

  return !text ? (
    <Stack
      justifyContent="center"
      className={classNames('icon-toast-warning-2', {
        'color-error': colorError,
        'color-warning': colorWarning,
      })}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="11" fill={color} />
        <path d="M12 8V14" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="17" r="0.5" transform="rotate(-180 12 17)" stroke="white" strokeLinecap="round" />
      </svg>
    </Stack>
  ) : (
    <PopoverCustom id={text} buttonContent={<IconToastWarning2 colorError size={16} />}>
      {text}
    </PopoverCustom>
  );
};
